<span><button (click)="invokeParentMethod()" class="btn btn-info" [disabled]="isDisabled">Complete</button></span>